import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { AuthService, DEFAULTSCREEN, httpRequestsAuthInterceptor, USERTYPE } from '@pinnakl/auth/providers';
import { AuthSecurityStorageService } from '@pinnakl/authentication';
import { providePinnaklEnvironment } from '@pinnakl/core/environment';
import { PinnaklErrorHandler } from '@pinnakl/core/errors-processing';
import { AG_GRID_KEY, AG_GRID_KEY_TOKEN, HTTP_SERVICE_URL, LOCATION } from '@pinnakl/shared/constants';
import { UserTypes } from '@pinnakl/shared/types';
import { providePinnaklPrimeNg, UiToastMessageService } from '@pinnakl/shared/ui/prime';
import { getAppInstanceToken, PageSubscriptionsHandler } from '@pinnakl/shared/util-helpers';
import { InlineSVGModule, PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';
import { AbstractSecurityStorage, AuthModule } from 'angular-auth-oidc-client';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

const authConfig = {
  ...environment.authConfig,
  configId: getAppInstanceToken(environment.authConfig?.configId, location?.host, environment.appName),
};

export const appConfig: ApplicationConfig = {
  providers: [
    providePinnaklPrimeNg(),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withXhr(), withInterceptors([httpRequestsAuthInterceptor])),
    provideRouter(appRoutes),
    providePinnaklEnvironment(environment),
    AuthService,
    {
      provide: HTTP_SERVICE_URL,
      useValue: environment.httpServerUrl,
    },
    { provide: DEFAULTSCREEN, useValue: { prod: 'dataroom', dev: 'dataroom' } },
    { provide: USERTYPE, useValue: UserTypes.EXTERNAL },
    {
      provide: PinnaklUIToastMessage,
      useClass: UiToastMessageService,
    },
    DialogService,
    MessageService,
    importProvidersFrom(AuthModule.forRoot({ config: authConfig })),
    { provide: AbstractSecurityStorage, useClass: AuthSecurityStorageService },
    importProvidersFrom(InlineSVGModule.forRoot({ baseUrl: '/assets/svg/' })),
    {
      provide: LOCATION,
      useValue: location,
    },
    {
      provide: ErrorHandler,
      useClass: PinnaklErrorHandler,
    },
    {
      provide: AG_GRID_KEY_TOKEN,
      useValue: AG_GRID_KEY,
    },
    PageSubscriptionsHandler,
  ],
};
